/**
 * Breadcrumb Adaptive Color
 * Ajuste automatiquement la couleur du breadcrumb selon la couleur de fond du header_page
 */

/**
 * Calcule la luminosité d'une couleur hexadécimale
 * @param {string} hex - Couleur hexadécimale (#RRGGBB)
 * @returns {number} - Luminosité (0-255)
 */
function getLuminance(hex) {
  // Convertir hex en RGB
  const rgb = hex.match(/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i);
  if (!rgb) return 128; // Valeur par défaut si format invalide

  const r = parseInt(rgb[1], 16);
  const g = parseInt(rgb[2], 16);
  const b = parseInt(rgb[3], 16);

  // Formule de luminosité perceptuelle
  return 0.299 * r + 0.587 * g + 0.114 * b;
}

/**
 * Ajuste la couleur du breadcrumb selon le fond du header_page
 */
function adjustBreadcrumbColor() {
  const breadcrumb = document.querySelector('.site-breadcrumb');
  const headerPage = document.querySelector('.paragraph--type--header-page');

  if (!breadcrumb || !headerPage) {
    return; // Pas de header_page sur cette page
  }

  // Récupérer la couleur de fond depuis le style inline (linear-gradient)
  const inlineStyle = headerPage.getAttribute('style');
  if (!inlineStyle) return;

  // Extraire la première couleur du linear-gradient (format: linear-gradient(to bottom, #XXXXXX 0%, ...))
  const hexMatch = inlineStyle.match(/linear-gradient\([^,]+,\s*(#[0-9a-fA-F]{6})/);

  let hex;
  if (hexMatch) {
    // Cas avec linear-gradient
    hex = hexMatch[1];
  } else {
    // Fallback : cas avec background-color simple (ancienne version)
    const bgColor = window.getComputedStyle(headerPage).backgroundColor;
    const rgbMatch = bgColor.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
    if (!rgbMatch) return;

    hex = '#' +
      ('0' + parseInt(rgbMatch[1], 10).toString(16)).slice(-2) +
      ('0' + parseInt(rgbMatch[2], 10).toString(16)).slice(-2) +
      ('0' + parseInt(rgbMatch[3], 10).toString(16)).slice(-2);
  }

  const luminance = getLuminance(hex);

  // Si fond foncé (luminance < 128), texte clair
  // Si fond clair (luminance >= 128), texte foncé
  if (luminance < 128) {
    breadcrumb.classList.add('breadcrumb--light');
    breadcrumb.classList.remove('breadcrumb--dark');
  } else {
    breadcrumb.classList.add('breadcrumb--dark');
    breadcrumb.classList.remove('breadcrumb--light');
  }
}

// Exécuter au chargement
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', adjustBreadcrumbColor);
} else {
  adjustBreadcrumbColor();
}

// Ré-exécuter si la page change (SPA, AJAX)
if (window.Drupal && window.Drupal.behaviors) {
  window.Drupal.behaviors.breadcrumbAdaptiveColor = {
    attach: function (context) {
      adjustBreadcrumbColor();
    }
  };
}
